import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const ClientsCreate = props => (
  <Create
    {...props}
    formatOnSubmit={data => ({
      ...data,
      birthday: data.birthday && data.birthday.toISOString(),
    })}
    resource="customers"
  >
    <Form />
  </Create>
);

ClientsCreate.propTypes = {};

export default ClientsCreate;
